import React from "react";

import { UilSearch } from "@iconscout/react-unicons";
import styles from "./SearchBox.module.scss";

type SearchBoxPropsType = {
  placeholder?: string;
};

function SearchBox(props: SearchBoxPropsType) {
  const { placeholder = "Search for a city ..." } = props;

  const uniqueId = "search-box" + React.useId();

  return (
    <label className={styles["container"]} htmlFor={uniqueId}>
      <input
        autoFocus
        className={styles["container__input"]}
        id={uniqueId}
        name={uniqueId}
        placeholder={placeholder}
        type="text"
      />
      <UilSearch className={styles["container__icon"]} size="1.5rem" />
    </label>
  );
}

export default React.memo(SearchBox);
